import React, { useMemo } from "react";

import { useGetMedicalPlanMappingsQuery } from "Features/MedicalPlanMappings/medicalPlanMappings.api";
import { Provider } from "react-redux";
import { Switch, Route } from "react-router-dom";
import BasicLoading from "ZeroRuby/BasicLoading";

import { ErrorHandler } from "Cobalt/ErrorHandler";
import PartnerProvider from "Common/PartnerProvider";
import { useSiteConfig } from "Common/Redux/siteConfig";
import ScrollToTop from "Common/ScrollToTop";
import { Card, CardSection } from "Theme/Card";
import { ThemeProvider } from "Theme/Context";

import { Chrome } from "./components";
import { RenewalSuitesComparisonContextProvider } from "./Context";
import { DetailedBenefitsComparisonPage, DetailedCostsComparisonPage, LandingPage } from "./pages";
import { createStore } from "./redux";
import { baseURL, detailedBenefitsComparisonURL, detailedCostsComparisonURL } from "./urls";

const AppPagesDumb = () => {
  const { isLoading: isLoadingSiteConfig, data: _siteConfig } = useSiteConfig();
  const { data, isLoading: isLoadinginMedicalPlanMappings, isError, error } = useGetMedicalPlanMappingsQuery({ companyPolicyID: "current" });
  const medicalPlanMappings = useMemo(() => data?.medicalPlanMappings || [], [data]);

  if (isLoadingSiteConfig || isLoadinginMedicalPlanMappings) {
    return <BasicLoading />;
  }
  if (isError) {
    return (
      <Card>
        <CardSection>
          <ErrorHandler name="RenewalSuitesComparison" action="Get current medical plan mappings" isError={isError} error={error} />
        </CardSection>
      </Card>
    );
  }
  return (
    <ScrollToTop>
      <Switch>
        <Route exact path={baseURL}>
          <LandingPage medicalPlanMappings={medicalPlanMappings} />
        </Route>
        <Route path={detailedBenefitsComparisonURL}>
          <DetailedBenefitsComparisonPage medicalPlanMappings={medicalPlanMappings} />
        </Route>
        <Route path={detailedCostsComparisonURL}>
          <DetailedCostsComparisonPage medicalPlanMappings={medicalPlanMappings} />
        </Route>
      </Switch>
    </ScrollToTop>
  );
};

const App = () => {
  const store = createStore({});

  return (
    <Provider store={store}>
      <ThemeProvider cobalt intuit={false}>
        <PartnerProvider>
          <RenewalSuitesComparisonContextProvider>
            <Chrome>
              <AppPagesDumb />
            </Chrome>
          </RenewalSuitesComparisonContextProvider>
        </PartnerProvider>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
